import ApiClient from '../ApiClient';
/* global axios */

class CopilotThreads extends ApiClient {
  constructor() {
    super('wizard/copilot_threads', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CopilotThreads();
